import React from 'react';
import { Grid } from '@mui/material';

const HoursSpent = ({ hoursSpent }) => {
  return (
    <div className="box">
      <Grid item className="allocated-hours">
        <p>Hours Spent</p>
        <div className="taskdetail-sidebar-right-col">
          <div className="allocated-hours-input">
            <p>
              {hoursSpent ? (
                hoursSpent
              ) : (
                <p className="due-date-input-none">None</p>
              )}
            </p>
          </div>
        </div>
      </Grid>
    </div>
  );
};

export default React.memo(HoursSpent);